<button type="button" class="btn btn-icon btn-delete"
        [ngClass]="{'icon': whichPage == null, 'btn-danger': whichPage != null}"
        (click)="deleteModal.show()"
        [disabled]="disabled"
        [ngbTooltip]="disabled ? disabledTooltip : ''"
        container="body">
  <i *ngIf="whichPage == null" class="fa fa-trash-o fa-lg" aria-hidden="true"></i>
  <span *ngIf="whichPage === 'details'">{{'Delete user' | translate}}</span>
  <span *ngIf="whichPage === 'profile'">{{'Delete my profile' | translate}}</span>
</button>

<div class="modal modal-danger fade" bsModal #deleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
     role="dialog"
     aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        {{'Are you sure that you want to delete' | translate}}<br><br>
        <span *ngIf="whichPage === 'details' || !whichPage">{{'user' | translate}}: {{getNameOfWhatToDelete()}}</span>
        <span *ngIf="whichPage === 'profile'">{{'your profile' | translate}}</span>?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger delete-modal-btn" (click)="deleteModal.hide(); getAnswer(true)"
                fxFlexAlign="end">{{'Yes' | translate}}
        </button>
        <button type="button" class="btn delete-modal-btn" (click)="deleteModal.hide(); getAnswer(false)"
                fxFlexAlign="end">{{'No' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
